(function (workerScript) {
    if (!/MSIE 10/i.test(navigator.userAgent)) {
        try {
            let blob = new Blob(["\
let internalIdToId = {};\
onmessage = function (event) {\
	let data = event.data;\
	let	name = data.name;\
	let	internalId = data.internalId;\
	let	time;\
	if(data.hasOwnProperty('time')) {\
		time = data.time;\
	}\
	switch (name) {\
		case 'setInterval':\
			internalIdToId[internalId] = setInterval(function () {\
				postMessage({internalId: internalId});\
			}, time);\
			break;\
		case 'clearInterval':\
			if (internalIdToId.hasOwnProperty (internalId)) {\
				clearInterval(internalIdToId[internalId]);\
				delete internalIdToId[internalId];\
			}\
			break;\
		case 'setTimeout':\
			internalIdToId[internalId] = setTimeout(function () {\
				postMessage({internalId: internalId});\
				if (internalIdToId.hasOwnProperty (internalId)) {\
					delete internalIdToId[internalId];\
				}\
			}, time);\
			break;\
		case 'clearTimeout':\
			if (internalIdToId.hasOwnProperty (internalId)) {\
				clearTimeout(internalIdToId[internalId]);\
				delete internalIdToId[internalId];\
			}\
			break;\
	}\
}\
"]);
            workerScript = window.URL.createObjectURL(blob);
        } catch (error) {
        }
    }
    let worker,
        internalIdToCallback = {},
        lastInternalId = 0,
        maxInternalId = 0x7FFFFFFF,
        logPrefix = 'TimerHack : ';
    if (typeof (Worker) !== 'undefined') {
        function getInternalId() {
            do {
                if (lastInternalId === maxInternalId) {
                    lastInternalId = 0;
                } else {
                    lastInternalId++;
                }
            } while (internalIdToCallback.hasOwnProperty(lastInternalId));
            return lastInternalId;
        }

        try {
            worker = new Worker(workerScript);
            window.setInterval = function (callback, time /* , parameters */) {
                let internalId = getInternalId();
                internalIdToCallback[internalId] = {
                    callback: callback,
                    parameters: Array.prototype.slice.call(arguments, 2)
                };
                worker.postMessage({
                    name: 'setInterval',
                    internalId: internalId,
                    time: time
                });
                return internalId;
            };
            window.clearInterval = function (internalId) {
                if (internalIdToCallback.hasOwnProperty(internalId)) {
                    delete internalIdToCallback[internalId];
                    worker.postMessage({
                        name: 'clearInterval',
                        internalId: internalId
                    });
                }
            };
            window.setTimeout = function (callback, time /* , parameters */) {
                let internalId = getInternalId();
                internalIdToCallback[internalId] = {
                    callback: callback,
                    parameters: Array.prototype.slice.call(arguments, 2),
                    isTimeout: true
                };
                worker.postMessage({
                    name: 'setTimeout',
                    internalId: internalId,
                    time: time
                });
                return internalId;
            };
            window.clearTimeout = function (internalId) {
                if (internalIdToCallback.hasOwnProperty(internalId)) {
                    delete internalIdToCallback[internalId];
                    worker.postMessage({
                        name: 'clearTimeout',
                        internalId: internalId
                    });
                }
            };
            worker.onmessage = function (event) {
                let data = event.data,
                    internalId = data.internalId,
                    request,
                    parameters,
                    callback;
                if (internalIdToCallback.hasOwnProperty(internalId)) {
                    request = internalIdToCallback[internalId];
                    callback = request.callback;
                    parameters = request.parameters;
                    if (request.hasOwnProperty('isTimeout') && request.isTimeout) {
                        delete internalIdToCallback[internalId];
                    }
                }
                if (typeof (callback) === 'string') {
                    try {
                        callback = new Function(callback);
                    } catch (error) {
                        console.log(logPrefix + 'Error parsing callback code string: ', error);
                    }
                }
                if (typeof (callback) === 'function') {
                    callback.apply(window, parameters);
                }
            };
            worker.onerror = function (event) {
                console.log(event,worker);
            };
        } catch (error) {
            console.log(logPrefix + 'Initialisation failed');
            console.error(error);
        }
    } else {
        console.log(logPrefix + 'Initialisation failed - HTML5 Web Worker is not supported');
    }
})('/js/timerworker.js');
